module.exports = new __parcel__URL__("apply_k_zh-cn.c4403091.webp").toString();